import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CoupleGallery from 'components/test/CoupleGallery.tsx';


// <CardMedia component="div"></CardMedia>
 export default function Welcome() {
  return ( 
    <Box sx={{
      py: 3,
      px: {xs: 0, md: 3},
      alignSelf:"center",
      alignContent: "center",
      alignItems: "center",
      justifyContent: "center",
      display: 'flex',
    }}>
      <Card sx={{ 
          maxWidth: 900,
          minWidth: 366,
          px: {xs: 0, md: 1},
          width: "100%",
          backgroundColor: "#ffeedd",
          display: 'flex', 
          flexDirection: "column",
        }}>
        <CardHeader 
          title="Welcome!" 
          titleTypographyProps = {{variant: "h3"}}
          />
        
        <CardContent sx={{px: 0}}>
          <Typography variant="body2" sx={{ color: 'text.secondary', px: 2, }} component="div">
          We are so excited to share our special day with you, and look forward to having the people that are most meaningful to us all together. Here's to a weekend full of love, connections new and old, revelry, and sunsets!
          </Typography>
          <CoupleGallery />
        </CardContent>
      </Card>
    </Box>
  );
}
